import { svg } from "../../Assets/svg";

const NoPermissionPage = () => {
  return (
    <div className="page-content h-100 px-40 py-40">
      <div className="d-flex flex-column flex-fill align-items-center justify-content-center">
        <div className="d-flex flex-column align-items-center gap-4">
          <div className="">{svg?.noPermissionIcon}</div>
          <h2 className="text-black fs-2 fw-bolder page-title mb-0 order-md-1 order-1">
            You do not have access of this page
          </h2>
          <p className="text-black fs-6 fw-normal page-title mb-0 order-md-1 order-1">
            You do not have permission to view this page. Please contact your
            administrator if you believe this is an error.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NoPermissionPage;
